export default __webpack_public_path__ + "static/media/381.4c37e415.gif";